const countryList = {
    AF: {
        text: 'Afghanistan',
        nationality: 'afghanisch',
    },
    EG: {
        text: 'Ägypten',
        nationality: 'ägyptisch',
    },
    AX: {
        text: 'Aland Islands',
        nationality: '',
        value: '+358',
        whitelist: {
            includes: ['4', '50'],
        },
    },
    AL: {
        text: 'Albanien',
        nationality: 'albanisch',
        value: '+355',
        whitelist: {
            includes: ['67', '68', '69'],
        },
    },
    DZ: {
        text: 'Algerien',
        nationality: 'algerisch',
    },
    AD: {
        text: 'Andorra',
        nationality: 'andorranisch',
        value: '+376',
        whitelist: {
            includes: ['3', '4', '6'],
        },
    },
    AO: {
        text: 'Angola',
        nationality: 'angolanisch',
    },
    AG: {
        text: 'Antigua und Barbuda',
        nationality: 'antiguanisch',
    },
    GQ: {
        text: 'Äquatorialguinea',
        nationality: 'äquatorialguineisch',
    },
    AR: {
        text: 'Argentinien',
        nationality: 'argentinisch',
    },
    AM: {
        text: 'Armenien',
        nationality: 'armenisch',
    },
    AZ: {
        text: 'Aserbaidschan',
        nationality: 'aserbaidschanisch',
    },
    ET: {
        text: 'Äthiopien',
        nationality: 'äthiopisch',
    },
    AU: {
        text: 'Australien',
        nationality: 'australisch',
    },
    BS: {
        text: 'Bahamas',
        nationality: 'bahamaisch',
    },
    BH: {
        text: 'Bahrain',
        nationality: 'bahrainisch',
    },
    BD: {
        text: 'Bangladesch',
        nationality: 'bangladeschisch',
    },
    BB: {
        text: 'Barbados',
        nationality: 'barbadisch',
    },
    BY: {
        text: 'Belarus',
        nationality: 'belarussisch',
        value: '+375',
        whitelist: {
            includes: ['25', '29', '33', '44'],
        },
    },
    BE: {
        text: 'Belgien',
        nationality: 'belgisch',
        value: '+32',
        whitelist: {
            includes: ['45', '46', '47', '48', '49'],
        },
    },
    BZ: {
        text: 'Belize',
        nationality: 'belizisch',
    },
    BJ: {
        text: 'Benin',
        nationality: 'beninisch',
    },
    BT: {
        text: 'Bhutan',
        nationality: 'bhutanisch',
    },
    BO: {
        text: 'Bolivien',
        nationality: 'bolivianisch',
    },
    BA: {
        text: 'Bosnien und Herzegowina',
        nationality: 'bosnisch, herzegowinisch',
        value: '+387',
        whitelist: {
            includes: ['61'],
        },
    },
    BW: {
        text: 'Botsuana',
        nationality: 'botsuanisch',
    },
    BR: {
        text: 'Brasilien',
        nationality: 'brasilianisch',
    },
    BN: {
        text: 'Brunei Darussalam',
        nationality: 'bruneiisch',
    },
    BG: {
        text: 'Bulgarien',
        nationality: 'bulgarisch',
        value: '+359',
        whitelist: {
            includes: ['887', '888', '889', '98', '99'],
        },
    },
    BF: {
        text: 'Burkina Faso',
        nationality: 'burkinisch',
    },
    BI: {
        text: 'Burundi',
        nationality: 'burundisch',
    },
    CL: {
        text: 'Chile',
        nationality: 'chilenisch',
    },
    CN: {
        text: 'China',
        nationality: 'chinesisch',
    },
    CK: {
        text: 'Cookinseln',
        nationality: '',
    },
    CR: {
        text: 'Costa Rica',
        nationality: 'costa-ricanisch',
    },
    CI: {
        text: "Côte d'Ivoire",
        nationality: 'ivorisch',
    },
    DK: {
        text: 'Dänemark',
        nationality: 'dänisch',
        value: '+45',
        whitelist: {
            includes: ['20', '31', '40', '42', '50', '53', '60', '61', '71', '81', '91', '93'],
        },
    },
    DE: {
        text: 'Deutschland',
        nationality: 'deutsch',
        value: '+49',
        whitelist: {
            includes: ['15', '17', '16'],
        },
    },
    DM: {
        text: 'Dominica',
        nationality: 'dominicanisch',
    },
    DO: {
        text: 'Dominikanische Republik',
        nationality: 'dominikanisch',
    },
    DJ: {
        text: 'Dschibuti',
        nationality: 'dschibutisch',
    },
    EC: {
        text: 'Ecuador',
        nationality: 'ecuadorianisch',
    },
    SV: {
        text: 'El Salvador',
        nationality: 'salvadorianisch',
    },
    ER: {
        text: 'Eritrea',
        nationality: 'eritreisch',
    },
    EE: {
        text: 'Estland',
        nationality: 'estnisch',
        value: '+372',
        whitelist: {
            includes: ['5', '8'],
        },
    },
    FO: {
        text: 'Färöer',
        nationality: '',
        value: '+298',
        whitelist: {
            includes: [
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '71',
                '72',
                '73',
                '74',
                '75',
                '76',
                '77',
                '78',
                '79',
                '91',
                '92',
                '93',
                '94',
                '95',
                '96',
                '97',
                '98',
                '99',
            ],
        },
    },
    FJ: {
        text: 'Fidschi',
        nationality: 'fidschianisch',
    },
    FI: {
        text: 'Finnland',
        nationality: 'finnisch',
        value: '+358',
        whitelist: {
            includes: ['4', '50'],
        },
    },
    FR: {
        text: 'Frankreich',
        nationality: 'französisch',
        value: '+33',
        whitelist: {
            includes: ['6', '7'],
        },
    },
    GA: {
        text: 'Gabun',
        nationality: 'gabunisch',
    },
    GM: {
        text: 'Gambia',
        nationality: 'gambisch',
    },
    GE: {
        text: 'Georgien',
        nationality: 'georgisch',
    },
    GH: {
        text: 'Ghana',
        nationality: 'ghanaisch',
    },
    GI: {
        text: 'Gibraltar',
        nationality: 'gibraltarisch',
        value: '+350',
        whitelist: {
            includes: ['5', '6'],
        },
    },
    GD: {
        text: 'Grenada',
        nationality: 'grenadisch',
    },
    GR: {
        text: 'Griechenland',
        nationality: 'griechisch',
        value: '+30',
        whitelist: {
            includes: ['68', '69'],
        },
    },
    GT: {
        text: 'Guatemala',
        nationality: 'guatemaltekisch',
    },
    GG: {
        text: 'Guernsey',
        nationality: '',
        value: '+44',
        whitelist: {
            includes: ['7'],
        },
    },
    GN: {
        text: 'Guinea',
        nationality: 'guineisch',
    },
    GW: {
        text: 'Guinea-Bissau',
        nationality: 'guinea-bissauisch',
    },
    GY: {
        text: 'Guyana',
        nationality: 'guyanisch',
    },
    HT: {
        text: 'Haiti',
        nationality: 'haitianisch',
    },
    HN: {
        text: 'Honduras',
        nationality: 'honduranisch',
    },
    IN: {
        text: 'Indien',
        nationality: 'indisch',
    },
    ID: {
        text: 'Indonesien',
        nationality: 'indonesisch',
    },
    IQ: {
        text: 'Irak',
        nationality: 'irakisch',
    },
    IR: {
        text: 'Iran, Islamische Republik',
        nationality: 'iranisch',
    },
    IE: {
        text: 'Irland',
        nationality: 'irisch',
        value: '+353',
        whitelist: {
            includes: ['85', '86', '87'],
        },
    },
    IS: {
        text: 'Island',
        nationality: 'isländisch',
        value: '+354',
        whitelist: {
            includes: ['6', '7', '8'],
        },
    },
    IL: {
        text: 'Israel',
        nationality: 'israelisch',
    },
    IT: {
        text: 'Italien',
        nationality: 'italienisch',
        value: '+39',
        whitelist: {
            includes: ['32', '33', '34', '35', '36', '37', '38', '39'],
        },
    },
    JE: {
        text: 'Jersey',
        nationality: '',
        value: '+44',
        whitelist: {
            includes: ['77', '97'],
        },
    },
    JM: {
        text: 'Jamaika',
        nationality: 'jamaikanisch',
    },
    JP: {
        text: 'Japan',
        nationality: 'japanisch',
    },
    YE: {
        text: 'Jemen',
        nationality: 'jemenitisch',
    },
    JO: {
        text: 'Jordanien',
        nationality: 'jordanisch',
    },
    KH: {
        text: 'Kambodscha',
        nationality: 'kambodschanisch',
    },
    CM: {
        text: 'Kamerun',
        nationality: 'kamerunisch',
    },
    CA: {
        text: 'Kanada',
        nationality: 'kanadisch',
    },
    CV: {
        text: 'Kap Verde',
        nationality: 'kap-verdisch',
    },
    KZ: {
        text: 'Kasachstan',
        nationality: 'kasachisch',
        value: '+7',
        whitelist: {
            includes: ['73', '77'],
        },
    },
    QA: {
        text: 'Katar',
        nationality: 'katarisch',
    },
    KE: {
        text: 'Kenia',
        nationality: 'kenianisch',
    },
    KG: {
        text: 'Kirgisistan',
        nationality: 'kirgisisch',
    },
    KI: {
        text: 'Kiribati',
        nationality: 'kiribatisch',
    },
    CO: {
        text: 'Kolumbien',
        nationality: 'kolumbianisch',
    },
    KM: {
        text: 'Komoren',
        nationality: 'komorisch',
    },
    CG: {
        text: 'Kongo',
        nationality: 'kongolesisch',
    },
    CD: {
        text: 'Kongo, Demokratische Republik',
        nationality: 'kongolesisch',
    },
    KP: {
        text: 'Korea, Demokratische Volksrepublik',
        nationality: 'koreanisch',
    },
    KR: {
        text: 'Korea, Republik',
        nationality: 'koreanisch',
    },
    HR: {
        text: 'Kroatien',
        nationality: 'kroatisch',
        value: '+385',
        whitelist: {
            includes: ['91', '92', '95', '97', '98', '99'],
        },
    },
    CU: {
        text: 'Kuba',
        nationality: 'kubanisch',
    },
    KW: {
        text: 'Kuwait',
        nationality: 'kuwaitisch',
    },
    LA: {
        text: 'Laos, Demokratische Volksrepublik',
        nationality: 'laotisch',
    },
    LS: {
        text: 'Lesotho',
        nationality: 'lesothisch',
    },
    LV: {
        text: 'Lettland',
        nationality: 'lettisch',
        value: '+371',
        whitelist: {
            includes: ['6', '9'],
        },
    },
    LB: {
        text: 'Libanon',
        nationality: 'libanesisch',
    },
    LR: {
        text: 'Liberia',
        nationality: 'liberianisch',
    },
    LY: {
        text: 'Libysch-Arabische Dschamahirija',
        nationality: 'libysch',
    },
    LI: {
        text: 'Liechtenstein',
        nationality: 'liechtensteinisch',
        value: '+423',
        whitelist: {
            includes: ['7', '664'],
        },
    },
    LT: {
        text: 'Litauen',
        nationality: 'litauisch',
        value: '+370',
        whitelist: {
            includes: ['6'],
        },
    },
    LU: {
        text: 'Luxemburg',
        nationality: 'luxemburgisch',
        value: '+352',
        whitelist: {
            includes: ['62', '65', '66', '67', '68', '69'],
        },
    },
    MG: {
        text: 'Madagaskar',
        nationality: 'madagassisch',
    },
    MW: {
        text: 'Malawi',
        nationality: 'malawisch',
    },
    MY: {
        text: 'Malaysia',
        nationality: 'malaysisch',
    },
    MV: {
        text: 'Malediven',
        nationality: 'maledivisch',
    },
    ML: {
        text: 'Mali',
        nationality: 'malisch',
    },
    MT: {
        text: 'Malta',
        nationality: 'maltesisch',
    },
    MA: {
        text: 'Marokko',
        nationality: 'marokkanisch',
        value: '+212',
        whitelist: {
            includes: ['6'],
        },
    },
    MH: {
        text: 'Marshallinseln',
        nationality: 'marshallisch',
    },
    MR: {
        text: 'Mauretanien',
        nationality: 'mauretanisch',
    },
    MU: {
        text: 'Mauritius',
        nationality: 'mauritisch',
    },
    MX: {
        text: 'Mexiko',
        nationality: 'mexikanisch',
    },
    FM: {
        text: 'Mikronesien, Föderierte Staaten von',
        nationality: 'mikronesisch',
    },
    MD: {
        text: 'Moldawien',
        nationality: 'moldauisch',
    },
    MC: {
        text: 'Monaco',
        nationality: 'monegassisch',
        value: '+377',
        whitelist: {
            includes: ['2', '3', '4', '6'],
        },
    },
    MN: {
        text: 'Mongolei',
        nationality: 'mongolisch',
    },
    ME: {
        text: 'Montenegro',
        nationality: 'montenegrinisch',
        value: '+382',
        whitelist: {
            includes: ['60', '63', '66', '67', '68', '69'],
        },
    },
    MZ: {
        text: 'Mosambik',
        nationality: 'mosambikanisch',
    },
    MM: {
        text: 'Myanmar',
        nationality: 'myanmarisch',
    },
    NA: {
        text: 'Namibia',
        nationality: 'namibisch',
    },
    NR: {
        text: 'Nauru',
        nationality: 'nauruisch',
    },
    NP: {
        text: 'Nepal',
        nationality: 'nepalesisch',
    },
    NZ: {
        text: 'Neuseeland',
        nationality: 'neuseeländisch',
    },
    NI: {
        text: 'Nicaragua',
        nationality: 'nicaraguanisch',
    },
    NL: {
        text: 'Niederlande',
        nationality: 'niederländisch',
        value: '+31',
        whitelist: {
            includes: ['61', '62', '63', '64', '65', '68'],
        },
    },
    NE: {
        text: 'Niger',
        nationality: 'nigrisch',
    },
    NG: {
        text: 'Nigeria',
        nationality: 'nigerianisch',
    },
    NU: {
        text: 'Niue',
        nationality: 'niueanisch',
    },
    MK: {
        text: 'Nordmazedonien',
        nationality: 'mazedonisch',
        value: '+389',
        whitelist: {
            includes: ['70', '71', '72', '75', '76', '77', '78'],
        },
    },
    NO: {
        text: 'Norwegen',
        nationality: 'norwegisch',
        value: '+47',
        whitelist: {
            includes: ['4', '9', '58', '59'],
        },
    },
    OM: {
        text: 'Oman',
        nationality: 'omanisch',
    },
    AT: {
        text: 'Österreich',
        nationality: 'österreichisch',
        value: '+43',
        whitelist: {
            includes: ['6'],
            slice: 1,
        },
    },
    PK: {
        text: 'Pakistan',
        nationality: 'pakistanisch',
    },
    PW: {
        text: 'Palau',
        nationality: 'palauisch',
    },
    PA: {
        text: 'Panama',
        nationality: 'panamaisch',
    },
    PG: {
        text: 'Papua-Neuguinea',
        nationality: 'papua-',
    },
    PY: {
        text: 'Paraguay',
        nationality: 'paraguayisch',
    },
    PE: {
        text: 'Peru',
        nationality: 'peruanisch',
    },
    PH: {
        text: 'Philippinen',
        nationality: 'philippinisch',
    },
    PL: {
        text: 'Polen',
        nationality: 'polnisch',
        value: '+48',
        whitelist: {
            includes: ['5', '6', '7', '8'],
        },
    },
    PT: {
        text: 'Portugal',
        nationality: 'portugiesisch',
        value: '+351',
        whitelist: {
            includes: ['9'],
        },
    },
    RW: {
        text: 'Ruanda',
        nationality: 'ruandisch',
    },
    RO: {
        text: 'Rumänien',
        nationality: 'rumänisch',
        value: '+40',
        whitelist: {
            includes: ['6', '7'],
        },
    },
    RU: {
        text: 'Russland',
        nationality: 'russisch',
        value: '+7',
        whitelist: {
            includes: ['9'],
        },
    },
    SB: {
        text: 'Salomonen',
        nationality: 'salomonisch',
    },
    ZM: {
        text: 'Sambia',
        nationality: 'sambisch',
    },
    WS: {
        text: 'Samoa',
        nationality: 'samoanisch',
    },
    SM: {
        text: 'San Marino',
        nationality: 'san-marinesisch',
        value: '+378',
        whitelist: {
            includes: ['61', '66'],
        },
    },
    ST: {
        text: 'São Tomé und Príncipe',
        nationality: 'são-toméisch',
    },
    SA: {
        text: 'Saudi-Arabien',
        nationality: 'saudi-arabisch',
    },
    SE: {
        text: 'Schweden',
        nationality: 'schwedisch',
        value: '+46',
        whitelist: {
            includes: ['070', '072', '073', '076', '079'],
        },
    },
    CH: {
        text: 'Schweiz',
        nationality: 'schweizerisch',
        value: '+41',
        whitelist: {
            includes: ['76', '77', '78', '79'],
        },
    },
    SN: {
        text: 'Senegal',
        nationality: 'senegalesisch',
    },
    RS: {
        text: 'Serbien',
        nationality: 'serbisch',
        value: '+381',
        whitelist: {
            includes: ['6'],
        },
    },
    SC: {
        text: 'Seychellen',
        nationality: 'seychellisch',
    },
    SL: {
        text: 'Sierra Leone',
        nationality: 'sierra-leonisch',
    },
    ZW: {
        text: 'Simbabwe',
        nationality: 'simbabwisch',
    },
    SG: {
        text: 'Singapur',
        nationality: 'singapurisch',
    },
    SK: {
        text: 'Slowakei',
        nationality: 'slowakisch',
        value: '+421',
        whitelist: {
            includes: ['9'],
        },
    },
    SI: {
        text: 'Slowenien',
        nationality: 'slowenisch',
        value: '+386',
        whitelist: {
            includes: ['30', '31', '40', '41', '51', '64', '70', '71'],
        },
    },
    SO: {
        text: 'Somalia',
        nationality: 'somalisch',
    },
    ES: {
        text: 'Spanien',
        nationality: 'spanisch',
        value: '+34',
        whitelist: {
            includes: ['6', '7'],
        },
    },
    LK: {
        text: 'Sri Lanka',
        nationality: 'sri-lankisch',
    },
    KN: {
        text: 'St. Kitts und Nevis',
        nationality: '',
    },
    LC: {
        text: 'St. Lucia',
        nationality: 'lucianisch',
    },
    VC: {
        text: 'St. Vincent und die Grenadinen',
        nationality: 'vincentisch',
    },
    ZA: {
        text: 'Südafrika',
        nationality: 'südafrikanisch',
    },
    SD: {
        text: 'Sudan',
        nationality: 'sudanesisch',
    },
    SR: {
        text: 'Suriname',
        nationality: 'surinamisch',
    },
    SZ: {
        text: 'Swasiland',
        nationality: 'swasiländisch',
    },
    SY: {
        text: 'Syrien',
        nationality: 'syrisch',
    },
    TJ: {
        text: 'Tadschikistan',
        nationality: 'tadschikisch',
    },
    TZ: {
        text: 'Tansania, Vereinigte Republik',
        nationality: 'tansanisch',
    },
    TH: {
        text: 'Thailand',
        nationality: 'thailändisch',
    },
    TL: {
        text: 'Timor-Leste',
        nationality: '',
    },
    TG: {
        text: 'Togo',
        nationality: 'togoisch',
    },
    TO: {
        text: 'Tonga',
        nationality: 'tongaisch',
    },
    TT: {
        text: 'Trinidad und Tobago',
        nationality: '',
    },
    TD: {
        text: 'Tschad',
        nationality: 'tschadisch',
    },
    CZ: {
        text: 'Tschechien',
        nationality: 'tschechisch',
        value: '+420',
        whitelist: {
            includes: ['6', '7'],
        },
    },
    TN: {
        text: 'Tunesien',
        nationality: 'tunesisch',
    },
    TR: {
        text: 'Türkei',
        nationality: 'türkisch',
        value: '+90',
        whitelist: {
            includes: ['5'],
        },
    },
    TM: {
        text: 'Turkmenistan',
        nationality: 'turkmenisch',
    },
    TV: {
        text: 'Tuvalu',
        nationality: 'tuvaluisch',
    },
    UG: {
        text: 'Uganda',
        nationality: 'ugandisch',
    },
    UA: {
        text: 'Ukraine',
        nationality: 'ukrainisch',
        value: '+380',
        whitelist: {
            includes: ['5', '6', '7', '8', '9'],
        },
    },
    HU: {
        text: 'Ungarn',
        nationality: 'ungarisch',
        value: '+36',
        whitelist: {
            includes: ['20', '30', '31', '50'],
        },
    },
    UY: {
        text: 'Uruguay',
        nationality: 'uruguayisch',
    },
    UZ: {
        text: 'Usbekistan',
        nationality: 'usbekisch',
    },
    VU: {
        text: 'Vanuatu',
        nationality: 'vanuatuisch',
    },
    VA: {
        text: 'Vatikanstadt',
        nationality: 'vatikanisch',
        value: '+379',
    },
    VE: {
        text: 'Venezuela',
        nationality: 'venezolanisch',
    },
    AE: {
        text: 'Vereinigte Arabische Emirate',
        nationality: '',
    },
    US: {
        text: 'Vereinigte Staaten',
        nationality: 'amerikanisch',
    },
    GB: {
        text: 'Vereinigtes Königreich',
        nationality: 'britisch',
        value: '+44',
        whitelist: {
            includes: ['71', '72', '73', '74', '75', '77', '78', '79'],
        },
    },
    VN: {
        text: 'Vietnam',
        nationality: 'vietnamesisch',
    },
    CF: {
        text: 'Zentralafrikanische Republik',
        nationality: 'zentralafrikanisch',
    },
    CY: {
        text: 'Zypern',
        nationality: 'zyprisch',
    },
};
export default countryList;
